import React from 'react';
import '../../App.css';
import AboutUs from "../AboutUs";
import ScrollToTop from "../ScrollToTop";

function Contact() {
  return (
    <>
      <AboutUs />
    </>
  );
}

export default Contact;
